export const SET_VANS_LIST = "SET_VANS_LIST";
export const SET_VANS_PAGE = "SET_VANS_PAGE";


export const setVansLists = (vans) => ({
  type: SET_VANS_LIST,
  payload: vans,
});

export const setVansPage = (page) => ({
  type: SET_VANS_PAGE,
  payload: page,
});


